import { lazy, Suspense, useState, useCallback } from 'react';

const ReceiptPopup = lazy(() => import('../../Modals/ReceiptPopup'));

export const useReceiptModal = ({ row, serverAppTheme }) => {
  const [isReceiptOpen, setIsReceiptOpen] = useState(false);

  const onOpenReceipt = useCallback(() => setIsReceiptOpen(true), []);
  const onCloseReceipt = useCallback(() => setIsReceiptOpen(false), []);

  const jsx = isReceiptOpen ? (
    <Suspense fallback={null}>
      <ReceiptPopup
        isOpen={isReceiptOpen}
        onClose={onCloseReceipt}
        row={row}
        serverAppTheme={serverAppTheme}
      />
    </Suspense>
  ) : null;

  return { onOpenReceipt, jsx };
};
